import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useProfiles() {
  return useQuery({
    queryKey: ["profiles"],
    queryFn: () => api.listProfiles(),
    staleTime: 60_000,
  });
}

export function useConnectProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.connectProfile,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["profiles"] });
      qc.invalidateQueries({ queryKey: ["usage"] });
      toast.success("Perfil conectado");
    },
  });
}

export function useDisconnectProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.disconnectProfile,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["profiles"] });
      qc.invalidateQueries({ queryKey: ["usage"] });
      toast.success("Perfil desconectado");
    },
  });
}
